import { adminApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const getDogProfile = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.GET_DOG_PROFILE)

  const searchParams = new URLSearchParams(window.location.search)
  const tokenFromUrl = searchParams.get('token')

  if (tokenFromUrl) {
    const response = await adminApi.getUserProfileInfo(tokenFromUrl)
    if (response.success) {
      const dogProfile = response.data

      useZustandStore.setState({ dogProfile: dogProfile.data })
    }
  }
  useZustandStore.getState().stopProcessing(ProcessingKey.GET_DOG_PROFILE)
}
